var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpriteIconWeb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  y: 710,
  viewBox: "-10 -10 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232E48",
  d: "M28.5 37c2.481 0 4.5-2.019 4.5-4.5S30.981 28 28.5 28a4.505 4.505 0 0 0-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5m-3.519-.274-4.127 4.128a.5.5 0 0 1-.708 0 .5.5 0 0 1 0-.708l4.128-4.127A5.5 5.5 0 1 1 34 32.5a5.5 5.5 0 0 1-9.019 4.226M42 21.5a.5.5 0 0 0-.5-.5H27v3h15zM26 21h-6.5a.5.5 0 0 0-.5.5V24h7zm17 .5v18c0 .827-.673 1.5-1.5 1.5h-17a.5.5 0 0 1 0-1h17a.5.5 0 0 0 .5-.5V25H19v13.5a.5.5 0 0 1-1 0v-17c0-.827.673-1.5 1.5-1.5h22c.827 0 1.5.673 1.5 1.5M24 23h1v-1h-1zm-2 0h1v-1h-1zm-2 0h1v-1h-1z"
}))));
export default SvgSpriteIconWeb;